<template>
    <div id="customer" v-if="is_initialized">
        <ErrorMessages :errors="errors" :description="$t('ui.general.error')" :is_closable="true"></ErrorMessages>
        <div class="ui segments">
            <div class="ui segment pointer" @click="div_toggle('basic_information')">
                <div class="ui horizontal divider">
                    <h3>
                        <i class="user icon"></i>
                        <!-- 基本資料 -->
                        {{ $t('ui.pages.customers.basic_information') }}
                        <i class="icon caret"
                            :class="[toggles.basic_information ? 'up' : 'down' ]"
                        >
                        </i>
                    </h3>
                </div>
            </div>
            <transition name="slide-fade">
                <div class="ui basic segment pointer" v-if="!toggles.basic_information" @click="div_toggle('basic_information')">
                    <h4>{{ $t('ui.pages.customers.show_basic_information') }}</h4>
                </div>
            </transition>
            <transition name="slide-fade">
                <div class="ui segment" v-if="toggles.basic_information">
                <div v-if="is_loading" class="ui active centered inline loader"></div>
                <div class="ui form" v-else-if="customer.identity">
                    <div class="fields">
                        <div class="sixteen wide field">
                            <label>
                                所屬站點
                                <i
                                    class="pointer remove circle red icon clear_dropdown"
                                    v-if="customer.station_identity"
                                    @click="
                                        customer.station_identity = null;
                                        $($refs.station_identity).dropdown('clear');
                                    ">
                                </i>
                            </label>
                            <select class="ui dropdown" v-dropdown v-model="customer.station_identity" ref="station_identity">
                                <option value="">{{ $t('ui.general.please_select') }}</option>
                                <option v-for="station in $store.state.provider.stations" :value="station.identity">{{ station.name }}</option>
                            </select>
                        </div>
                    </div>
                    <div class="fields">
                        <div class="eight wide required field">
                            <label>{{ $t('models.attributes.customers.username') }}</label>
                            <input type="text" name="username" v-model="customer.username">
                        </div>
                        <div class="eight wide required field computer column">
                            <label>{{ $t('models.attributes.customers.company_name') }}</label>
                            <input type="text" name="company_name" v-model="customer.company_name">
                        </div>
                    </div>
                    <div class="fields">
                        <div class="eight wide field computer column">
                            <label :data-tooltip="old_password">{{ $t('models.attributes.customers.password') }}</label>
                            <input type="password" name="password" v-model="customer.password">
                        </div>
                        <div class="eight wide field computer column">
                            <label>{{ $t('models.attributes.customers.password_confirmation') }}</label>
                            <input type="password" autocomplete="off" name="password_confirmation" v-model="customer.password_confirmation">
                        </div>
                    </div>
                    <div class="fields">
                        <div class="eight wide field computer column">
                            <label>{{ $t('models.attributes.customers.company_short_name') }}</label>
                            <input type="text" name="company_short_name" v-model="customer.company_short_name">
                        </div>
                        <div class="eight wide field computer column">
                            <label>{{ $t('models.attributes.customers.company_en_name') }}</label>
                            <input type="text" name="company_en_name" v-model="customer.company_en_name">
                        </div>
                    </div>
                    <div class="fields">
                        <div class="six wide field">
                            <label>{{ $t('models.attributes.customers.email') }}</label>
                            <input type="text" name="email" v-model="customer.email">
                        </div>
                        <div class="five wide field computer column">
                            <label>{{ $t('models.attributes.customers.phone') }}</label>
                            <input type="text" name="phone" v-model="customer.phone">
                        </div>
                        <div class="five wide field computer column">
                            <label>{{ $t('models.attributes.customers.fax') }}</label>
                            <input type="text" name="fax" v-model="customer.fax">
                        </div>
                    </div>
                    <div class="fields">
                        <div class="eight wide field">
                            <div class="ui checkbox" v-checkbox>
                                <input type="checkbox" tabindex="0" class="hidden" v-model="customer.can_use_associated_partitions">
                                <label>
                                    <!-- 是否開放使用「我的號碼區間」 -->
                                    {{ $t('ui.pages.customers.is_open_use_associated_partition') }}
                                </label>
                            </div>
                        </div>
                        <div class="eight wide field">
                            <div class="ui checkbox" v-checkbox>
                                <input type="checkbox" tabindex="0" class="hidden" v-model="customer.can_use_provider_partitions">
                                <label>
                                    <!-- 是否開放使用「自用號碼區間」 -->
                                    {{ $t('ui.pages.customers.is_open_use_use_yourself_partition') }}
                                </label>
                            </div>
                        </div>
                    </div>
                   <div class="fields">
                        <div class="eight wide field">
                            <div class="ui checkbox" v-checkbox>
                                <input type="checkbox" tabindex="0" class="hidden" v-model="customer.is_modification_allowed">
                                <label>
                                    是否開放修改運單
                                </label>
                            </div>
                        </div>
                    </div>
                    <div class="ui divider"></div>
                    <div class="right floated">
                        <div class="ui positive button" @click="update_customer">
                            {{ $t('ui.general.update') }}
                        </div>
                    </div>
                    <div class="clear"></div>
                </div>
            </div>
            </transition>
        </div>

        <div class="ui segments">
            <div class="ui segment pointer" @click="div_toggle('common_sender_information')">
                <div class="ui horizontal divider">
                    <h3>
                        <i class="user icon"></i>
                        <!-- 常用寄件人資訊 -->
                        {{ $t('ui.pages.customers.common_sender_information') }}
                        <i class="icon caret"
                            :class="[toggles.common_sender_information ? 'up' : 'down' ]"
                        >
                        </i>
                    </h3>
                </div>
            </div>
            <transition name="slide-fade">
                <div class="ui basic segment pointer" v-if="!toggles.common_sender_information" @click="div_toggle('common_sender_information')">
                    <h4>{{ $t('ui.pages.customers.show_common_sender_information') }}</h4>
                </div>
            </transition>
            <transition name="slide-fade">
                <div class="ui segment" v-if="toggles.common_sender_information">
                    <div v-if="is_loading" class="ui active centered inline loader"></div>
                    <div class="ui form" v-else-if="customer.identity">
                        <div class="fields">
                            <div class="eight wide field">
                                <label>{{ $t('models.attributes.customers.default_sender_company_name') }}</label>
                                <input type="text" name="default_sender_name" v-model="customer.default_sender_company_name">
                            </div>
                            <div class="eight wide field">
                                <label>{{ $t('models.attributes.customers.default_sender_name') }}</label>
                                <input type="text" name="default_sender_name" v-model="customer.default_sender_name">
                            </div>
                        </div>
                        <div class="fields">
                            <div class="three wide field">
                                <label>{{ $t('models.attributes.customers.default_sender_zip_code') }}</label>
                                <input type="text" name="default_sender_zip_code" v-model="customer.default_sender_zip_code">
                            </div>
                            <div class="eight wide field">
                                <label>{{ $t('models.attributes.customers.default_sender_address') }}</label>
                                <input type="text" name="default_sender_address" v-model="customer.default_sender_address">
                            </div>
                            <div class="five wide field">
                                <label>{{ $t('models.attributes.customers.default_sender_phone') }}</label>
                                <input type="text" name="default_sender_phone" v-model="customer.default_sender_phone">
                            </div>
                        </div>
                        <div class="fields">
                            <div class="six wide field">
                                <label>{{ $t('models.attributes.customers.default_sender_email') }}</label>
                                <input type="text" name="default_sender_email" v-model="customer.default_sender_email">
                            </div>
                            <div class="five wide field">
                                <label>{{ $t('models.attributes.customers.default_sender_fax') }}</label>
                                <input type="text" name="default_sender_fax" v-model="customer.default_sender_fax">
                            </div>
                            <div class="five wide field">
                                <label>{{ $t('models.attributes.customers.default_sender_url') }}</label>
                                <input type="text" name="default_sender_url" v-model="customer.default_sender_url">
                            </div>
                        </div>
                        <div class="ui divider"></div>
                        <div class="right floated">
                            <div class="ui positive button" @click="update_customer">
                                {{ $t('ui.general.update') }}
                            </div>
                        </div>
                        <div class="clear"></div>
                    </div>
                </div>
            </transition>
        </div>

        <div class="ui segments">
            <div class="ui segment pointer" @click="div_toggle('common_consignee_information')">
                <div class="ui horizontal divider">
                    <h3>
                        <i class="user icon"></i>
                        <!-- 常用收件人資訊 -->
                        {{ $t('ui.pages.customers.common_consignee_information') }}
                        <i class="icon caret"
                            :class="[toggles.common_consignee_information ? 'up' : 'down' ]"
                        >
                        </i>
                    </h3>
                </div>
            </div>
            <transition name="slide-fade">
                <div class="ui basic segment pointer" v-if="!toggles.common_consignee_information" @click="div_toggle('common_consignee_information')">
                    <h4>{{ $t('ui.pages.customers.show_common_consignee_information') }}</h4>
                </div>
            </transition>
            <transition name="slide-fade">
                <div class="ui segment" v-if="toggles.common_consignee_information">
                    <div v-if="is_loading" class="ui active centered inline loader"></div>
                    <div class="ui form" v-else-if="customer.identity">
                        <div class="fields">
                            <div class="eight wide field">
                                <label>{{ $t('models.attributes.customers.default_consignee_company_name') }}</label>
                                <input type="text" name="default_sender_name" v-model="customer.default_consignee_company_name">
                            </div>
                            <div class="eight wide field">
                                <label>{{ $t('models.attributes.customers.default_consignee_name') }}</label>
                                <input type="text" name="default_consignee_name" v-model="customer.default_consignee_name">
                            </div>
                        </div>
                        <div class="fields">
                            <div class="three wide field">
                                <label>{{ $t('models.attributes.customers.default_consignee_zip_code') }}</label>
                                <input type="text" name="default_consignee_zip_code" v-model="customer.default_consignee_zip_code">
                            </div>
                            <div class="eight wide field">
                                <label>{{ $t('models.attributes.customers.default_consignee_address') }}</label>
                                <input type="text" name="default_consignee_address" v-model="customer.default_consignee_address">
                            </div>
                            <div class="five wide field">
                                <label>{{ $t('models.attributes.customers.default_consignee_phone') }}</label>
                                <input type="text" name="default_consignee_phone" v-model="customer.default_consignee_phone">
                            </div>
                        </div>
                        <div class="fields">
                            <div class="eight wide field">
                                <label>{{ $t('models.attributes.customers.default_consignee_email') }}</label>
                                <input type="text" name="default_consignee_email" v-model="customer.default_consignee_email">
                            </div>
                            <div class="eight wide field">
                                <label>{{ $t('models.attributes.customers.default_consignee_fax') }}</label>
                                <input type="text" name="default_consignee_fax" v-model="customer.default_consignee_fax">
                            </div>
                        </div>

                        <div class="ui divider"></div>
                        <div class="right floated">
                            <div class="ui positive button" @click="update_customer">
                                {{ $t('ui.general.update') }}
                            </div>
                        </div>
                        <div class="clear"></div>
                    </div>
                </div>
            </transition>
        </div>

        <div class="ui segments">
            <div class="ui segment pointer" @click="div_toggle('contracts')">
                <div class="ui horizontal divider">
                    <h3>
                        <i class="clipboard icon"></i>
                        <!-- 合約 -->
                        {{ $t('ui.pages.customers.contracts') }}
                        <i class="icon caret"
                            :class="[toggles.contracts ? 'up' : 'down' ]"
                        >
                        </i>
                        <router-link
                            v-if="toggles.contracts"
                            :to="{
                                name: 'new_provider_contract',
                                params: {
                                    customer_identity: customer.identity
                                }
                            }">
                            <i class="add icon"></i>
                        </router-link>
                    </h3>
                </div>

            </div>
            <transition name="slide-fade">
                <div class="ui basic segment pointer" v-if="!toggles.contracts" @click="div_toggle('contracts')">
                    <h4>{{ $t('ui.pages.customers.show_contracts') }}</h4>
                </div>
            </transition>
            <transition name="slide-fade">
                <div class="ui basic segment pointer" v-if="toggles.contracts">
                <div v-if="is_loading" class="ui active centered inline loader"></div>
                <table class="ui table">
                    <thead>
                        <tr>
                            <th>{{ $t('ui.pages.customers.contract.name') }}</th>
                            <th>{{ $t('ui.pages.customers.contract.created_at') }}</th>
                            <th>{{ $t('ui.general.operate') }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="contract in customer.contracts" :contract="contract" :key="contract.identity">
                            <td>
                                {{ contract.name }}
                            </td>
                            <td>{{ human_datetime(contract.created_at) }}</td>
                            <td>
                                <router-link
                                    class="ui basic primary button"
                                    :key="contract.identity"
                                    :to="{
                                        name: 'provider_contract',
                                        params: {
                                            customer_identity: customer.identity,
                                            contract_identity: contract.identity
                                        }
                                    }">
                                    {{ $t('ui.general.show') }}
                                </router-link>
                                <a href="#" class="ui basic red button"
                                    v-if="customer.contracts.length > 1"
                                    @click.prevent="delete_contract(contract.identity, contract.name)">
                                    {{ $t('ui.general.delete') }}
                                </a>
                            </td>
                        </tr>
                        <tr v-if="!customer.contracts.length" class="center aligned">
                            <td colspan="2" >
                                <h5>
                                    {{ $t('ui.general.no_data') }}
                                </h5>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            </transition>
        </div>
    </div>
</template>

<script>
import ErrorMessages from '@toolbox/error_box/main.vue'
export default {
    name: "Customer",
    data() {
        return {
            is_initialized: false,
            is_loading: false,
            errors: [],
            customer: {},
            old_password: "",
            toggles: {
                basic_information: true,
                common_sender_information: false,
                common_consignee_information: false,
                contracts: false,
            }
        }
    },
    computed: {
    },
    mounted() {
        this.init()
    },
    created() {
    },
    methods: {
        div_toggle(item_name = "") {
            _.forEach(this.toggles, (value, key) => {
                if (key != item_name) {
                    this.toggles[key] = false
                }
            })
            if (item_name) {
                this.toggles[item_name] = !this.toggles[item_name]
            }
        },
        async init() {
            try {
                await new Promise(resolve => {
                    this.is_initialized = false
                    resolve()
                })
                await this.fetch_customer()
                await new Promise(resolve => {
                    this.is_initialized = true
                    resolve()
                })
            } catch (e) {
                switch (e) {
                    default:
                    console.log("init error: ")
                    console.log(e)
                }
            } finally {
                await this.form_validation()
            }
        },
        fetch_customer() {
            var url = new RestUrl(this.$store.state.provider.routes.api_v1_provider_customer).parse({
                "customer_identity": this.$route.params.customer_identity,
            })
            this.is_loading = true
            return axios.get(url, {headers: { Authorization: localStorage.getItem("authentication_token") }})
                .then(response => {
                    if (response.data.status == "success") {
                        this.old_password = response.data.customer.password
                        response.data.customer.password = null
                        this.customer = response.data.customer
                    } else {
                        return Promise.reject(response.data)
                    }
                })
                .catch(error => {
                    if (error.response) {
                        switch (error.response.status) {
                            default:
                            this.errors.push(error.response.status + ' ' + error.response.statusText)
                        }
                        // this.$noty.error('取得 客戶 失敗: ' + error.response.status + ' ' + error.response.statusText)
                        this.$noty.error(
                            this.$t('ui.notifications.error.find__name',{
                                name: this.$t('models.customers'),
                                reason: ': ' + error.response.status + ' ' + error.response.statusText
                            })
                        )
                    } else if (error.errors) {
                        // this.$noty.error('取得 客戶 失敗: ' + error.errors)
                        this.$noty.error(
                            this.$t('ui.notifications.error.fetch__name', {
                                name: this.$t('models.customers'),
                                reason: ': ' + error.errors
                            })
                        )
                    } else {
                        this.errors.push(this.$t('ui.general.server_offline'))
                        this.$noty.error(this.$t('ui.general.server_offline'))
                    }
                    return Promise.reject(error)
                })
                .finally(() => {
                    this.is_loading = false
                })
        },
        form_validation() {
            $('.ui.form').form({
                on: 'blur',
                fields: {
                    username: "empty",
                    company_name: "empty",
                }
            })
        },
        update_customer() {
            var data = this.customer

            this.errors = []
            if (data.password != "" && (data.password != data.password_confirmation)) {
                // 密碼與確認密碼不相符
                var error_content = this.$t('ui.pages.customers.helps.the_password_does_not_match_the_confirmation_password')
                this.errors.push(error_content)
                this.$noty.error(error_content)
            } else {
                if (this.customer.username && this.customer.company_name) {
                    delete data.password_confirmation

                    var url = new RestUrl(this.$store.state.provider.routes.api_v1_provider_customer_update).parse({
                        "customer_identity": this.$route.params.customer_identity,
                    })

                    this.is_loading = true
                    axios.post(url, data, {headers: { Authorization: localStorage.getItem("authentication_token") }})
                        .then(response => {
                            if (response.data.status == "success") {
                                this.customer = response.data.customer
                                this.customer.password = null
                                this.customer.password_confirmation = null
                                this.$bus.$emit("out_of_date", this.$store.state.instance_identity, "customers")
                                // this.$noty.success('更新 客戶 成功')
                                this.$noty.success(
                                    this.$t('ui.notifications.success.update__name', {
                                        name: this.$t('models.customers')
                                    })
                                )
                                this.$router.push({name: 'provider_customers'})
                            } else {
                                // this.$noty.error('更新 客戶 失敗')
                                this.$noty.error(
                                    this.$t('ui.notifications.error.update__name', {
                                        name: this.$t('models.customers'),
                                    })
                                )
                            }
                        })
                        .catch(error => {
                            if (error.response) {
                                switch (error.response.status) {
                                    default:
                                    this.errors.push(error.response.status + ' ' + error.response.statusText)
                                }
                                // this.$noty.error('更新 客戶 失敗: ' + error.response.status + ' ' + error.response.statusText)
                                this.$noty.error(
                                    this.$t('ui.notifications.error.update__name', {
                                        name: this.$t('models.customers'),
                                        reason: ': ' + error.response.status + ' ' + error.response.statusText
                                    })
                                )
                            } else {
                                this.errors.push(this.$t('ui.general.server_offline'))
                                this.$noty.error(this.$t('ui.general.server_offline'))
                            }
                            return Promise.reject(error)
                        })
                        .finally(() => {
                            this.is_loading = false
                        })
                } else {
                    // 請檢查必填欄位(*標記)是否確實填寫
                    this.errors.push(
                        this.$t('ui.notifications.error.please_check_to_write_in_the_required_fields_mark')
                    )
                }
            }
        },
        delete_contract(contract_identity, contract_name) {
            var confirm_staring = this.$t('ui.notifications.warning.are_you_sure_to_delete_it') + '\n\n' +
                this.customer.company_name + '[' + contract_name + ']'

            if (
                confirm(confirm_staring)
            ) {
                this.is_loading = true
                var url = new RestUrl(this.$store.state.provider.routes.api_v1_provider_contract_delete).parse({
                    "contract_identity": contract_identity,
                })

                axios.get(url, {headers: { Authorization: localStorage.getItem("authentication_token") }})
                    .then(response => {
                        if (response.data.status == "success") {
                            this.$parent.fetch_customers()
                            // this.$noty.success('刪除客戶成功')
                            this.$bus.$emit("out_of_date", this.$store.state.instance_identity, "customers")
                            this.$noty.success(
                                this.$t('ui.notifications.success.delete__name', {
                                    name: this.$t('models.contracts')
                                })
                            )
                        } else {
                            // this.$noty.error('刪除客戶失敗')
                            this.$noty.error(
                                this.$t('ui.notifications.error.delete__name', {
                                    name: this.$t('models.contracts'),
                                })
                            )
                        }
                    })
                    .catch(error => {
                        console.log(error.response)
                        // this.$noty.error('刪除客戶失敗')
                        this.$noty.error(
                            this.$t('ui.notifications.error.delete__name', {
                                name: this.$t('models.customers'),
                                reason: ': ' + error.response
                            })
                        )
                    }).finally(() => {
                        this.is_loading = false
                    })
            }
        },
    },
    components: {
        ErrorMessages,
    }
}
</script>

<style scoped lang="scss">
</style>
